import React from 'react';
import { Box, IconButton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

interface MobileActionButtonsProps {
  onCancel: () => void;
  onSave: () => void;
  isSaveDisabled?: boolean;
  cancelAriaLabel?: string;
  saveAriaLabel?: string;
}

/**
 * MobileActionButtons - Reusable action buttons (Cancel/Save) for mobile settings
 * Extracted from MobileAccountSettings (appears 6+ times)
 */
function MobileActionButtons({
  onCancel,
  onSave,
  isSaveDisabled = false,
  cancelAriaLabel = 'Cancel',
  saveAriaLabel = 'Save',
}: MobileActionButtonsProps): JSX.Element {
  return (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mt: 1 }}>
      <IconButton
        onClick={onCancel}
        aria-label={cancelAriaLabel}
        sx={{
          bgcolor: '#F5F5F5',
          '&:hover': { bgcolor: '#E0E0E0' },
        }}
      >
        <CloseIcon />
      </IconButton>
      <IconButton
        onClick={onSave}
        disabled={isSaveDisabled}
        aria-label={saveAriaLabel}
        sx={{
          bgcolor: isSaveDisabled ? '#CCCCCC' : '#324C80',
          color: 'white',
          '&:hover': { bgcolor: isSaveDisabled ? '#CCCCCC' : '#1B3059' },
          '&:disabled': {
            bgcolor: '#CCCCCC',
            color: '#999999',
          },
        }}
      >
        <CheckIcon />
      </IconButton>
    </Box>
  );
}

export default MobileActionButtons;
